/* global axios */

function accountIdFromRoute() {
  const isInsideAccountScopedURLs = window.location.pathname.includes('/app/accounts');
  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }
  return '';
}

class TelephonyConversationsAPI {
  byCallId(callId, accountId) {
    const id = accountId || accountIdFromRoute();
    return axios.get(`/api/v1/accounts/${id}/telephony/conversations/by_call_id`, {
      params: { call_id: callId },
    });
  }

  ensureByCallId({ callId, accountId, inboxId, contactId, sourceId, message }) {
    const id = accountId || accountIdFromRoute();
    return axios.post(`/api/v1/accounts/${id}/telephony/conversations/ensure_by_call_id`, {
      call_id: callId,
      inbox_id: inboxId,
      contact_id: contactId,
      source_id: sourceId,
      message,
    });
  }
}

export default new TelephonyConversationsAPI();
